export default "__VITE_ASSET__C8bJY$bT__"